import ConeCrusherCH from './ConeCrusherCH.png';
import ConeCrusherBW from '../../Generic/GenericCrusher/images/ConeCrusherBW.png';
import ConeCrusherCH2 from './ConeCrusherCH_2.png';
import ConeCrusherCHBin from './ConeCrusherCH_Bin.png';
import ConeCrusherCH800 from './ConeCrusherCH_800.png';
import ConeCrusherCH800Property from './ConeCrusherCH_800_Property.png';
import ConeCrusherCHBin800 from './ConeCrusherCH_Bin_800.png';
import GenericCrusherHighBinBW from '../../Generic/GenericCrusher/images/GenericCrusherHighBinBW.png';

const is800Series = (modelName: string) => /^CH8\d{2}i?$/.test(modelName);

const getStandardImage = (modelName: string, propertyPanel: boolean) => {
  if (is800Series(modelName)) {
    return propertyPanel ? ConeCrusherCH800Property : ConeCrusherCH800;
  }

  return propertyPanel ? ConeCrusherCH2 : ConeCrusherCH;
};

const getHighBinImage = (modelName: string) =>
  is800Series(modelName) ? ConeCrusherCHBin800 : ConeCrusherCHBin;

export const getImageCrusherCH = (
  showCustomModel: boolean,
  useHighBin: boolean,
  modelName: string,
) => {
  if (useHighBin) {
    return showCustomModel
      ? GenericCrusherHighBinBW
      : getHighBinImage(modelName);
  } else {
    return showCustomModel ? ConeCrusherBW : getStandardImage(modelName, false);
  }
};

export const getImageCrusherCH2 = (
  showCustomModel: boolean,
  useHighBin: boolean,
  modelName: string,
) => {
  if (useHighBin) {
    return showCustomModel
      ? GenericCrusherHighBinBW
      : getHighBinImage(modelName);
  } else {
    return showCustomModel ? ConeCrusherBW : getStandardImage(modelName, true);
  }
};
